import data from '../data/emblem'

const emblem = {
  namespaced: true,
  state: {
    data,
    selectedElement: {},
    selectedItem: {},
  },
  mutations: {
    init (state) {
      state.selectedElement = {}
      state.selectedItem = {}
    },
    // 選択状態の初期化
    clearEmblem (state) {
      state.selectedElement = {}
      state.selectedItem = {}
    },
    // エリアの選択
    changeElement (state, payload) {
      state.selectedElement = payload
    },
    // アイテムの選択
    changeItem (state, payload) {
      state.selectedItem = payload
    },
  }
}
export default emblem
